import React from 'react'
import styled from 'styled-components'
import { Currency } from '@nominex/nomiswap-sdk'
import { LinkExternal } from '@nominex/dex-uikit'
import { useTranslation } from 'contexts/Localization'
import { useWagmi } from 'libs/wagmi'
import { getBlockExplorerLink } from 'utils'
import truncateHash from 'utils/truncateHash'
import AddToWalletButton from 'components/AddToWallet/AddToWalletButton'

const StyledLinkExternal = styled(LinkExternal)`
  & svg {
    width: 12px;
  }
`

const TokenAddressPanel: React.FC<{ currency: Currency }> = ({ currency }) => {
  const { t } = useTranslation()
  const { chainId } = useWagmi()

  const token = currency?.isToken ? currency : null

  if (!token) {
    return null
  }

  return (
    <div className="flex gap-12">
      <div className="flex gap-4 items-center">
        <div className="text-12 text-dark-gray-100 notranslate" translate="no">
          {t('%symbol% address', { symbol: token.symbol })}
        </div>
        <StyledLinkExternal fontSize="12px" href={getBlockExplorerLink(token.address, 'address', chainId)} noTranslate>
          {truncateHash(token.address)}
        </StyledLinkExternal>
      </div>
      <div className="text-14 flex items-center">
        <AddToWalletButton token={token} />
      </div>
    </div>
  )
}

export default TokenAddressPanel
